import { createCustomTheme } from '@domains/subscription/theme'
import { ThemeProvider } from '@mui/material'
import useMaterialNotification from 'hooks/useMaterialNotification'
import type { CustomerPlanDiscount } from '../api/api'
import { useCreateCustomerPlanDiscount, useCustomerPlanDiscount, useDeleteCustomerPlanDiscount } from '../api/queries'
import { CreateCustomerPlanDiscount } from '../usecase/CreateCustomerPlanDiscount'

interface CreateCustomerPlanDiscountFactoryProps {
  customerId: string
  currency: string
  onChange?: () => void
}

export const CreateCustomerPlanDiscountFactory = ({ customerId, currency, onChange }: CreateCustomerPlanDiscountFactoryProps) => {
  const { data: discount, isLoading } = useCustomerPlanDiscount(customerId)
  const { mutate: createCustomerPlanDiscount, isLoading: isCreating } = useCreateCustomerPlanDiscount(customerId)
  const { mutate: deleteCustomerPlanDiscount, isLoading: isDeleting } = useDeleteCustomerPlanDiscount(customerId)

  const notify = useMaterialNotification()

  const handleCreateCustomerPlanDiscount = async (flatAndPerUnitDiscount: CustomerPlanDiscount) => {
    createCustomerPlanDiscount(flatAndPerUnitDiscount, {
      onSuccess: () => {
        notify('Customer plan discount created')
        onChange?.()
      },
    })
  }

  const handleDeleteCustomerPlanDiscount = async () => {
    deleteCustomerPlanDiscount(undefined, {
      onSuccess: () => {
        notify('Customer plan discount deleted')
        onChange?.()
      },
    })
  }

  return (
    <ThemeProvider theme={createCustomTheme()}>
      <CreateCustomerPlanDiscount
        onCreateDiscount={handleCreateCustomerPlanDiscount}
        onDeleteDiscount={handleDeleteCustomerPlanDiscount}
        currency={currency}
        discount={discount ? discount : undefined}
        isLoading={isLoading}
        isPatching={isCreating}
        isDeleting={isDeleting}
      />
    </ThemeProvider>
  )
}
